/* eslint-disable @typescript-eslint/no-explicit-any */
import firebase from "@/plugins/firebase";
import "@/types";
import axios from "axios";
import router from "@/router";

const lms = {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {
    addCourseReg: async (
      context: any,
      prms: { uid: string; courseId: string }
    ) => {
      const timestamp = firebase.firestore.Timestamp.now();
      const cregRef = firebase.firestore().collection("/courseRegistrations");

      const cregCheck = await cregRef
        .where("uid", "==", prms.uid)
        .where("courseId", "==", prms.courseId)
        .get();

      if (cregCheck.empty) {
        await cregRef.add({
          uid: prms.uid,
          courseId: prms.courseId,
          dateCreated: timestamp,
          dateGraduated: null,
          progress: 0,
          isActive: true,
          roleId: "student"
        });
      }
    },

    removeCourseReg: async (context: any, cregId: string) => {
      await firebase
        .firestore()
        .doc(`/courseRegistrations/${cregId}`)
        .delete();
    }
  }
};

export default lms;
